/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {AnimatedSegmentModel} from "@/models/animatedSegmentModel";

export class AnimatedSegmentTransitionModel extends JsonModel<AnimatedSegmentTransitionModel.IJson> {
  public static chooseTransitionFromRandom(random: number): AnimatedSegmentTransitionModel.Type {
    const transitions = [
      {type: AnimatedSegmentTransitionModel.Type.CrossFade, threshold: 0.8},
      {type: AnimatedSegmentTransitionModel.Type.SlideLeft, threshold: 0.9},
      {type: AnimatedSegmentTransitionModel.Type.SlideDown, threshold: 1.0},
    ];

    for (const transition of transitions) {
      if (random <= transition.threshold) {
        return transition.type;
      }
    }

    return AnimatedSegmentTransitionModel.Type.CrossFade;
  }

  public apply(segment: AnimatedSegmentModel): AnimatedSegmentModel {
    if (this.type === AnimatedSegmentTransitionModel.Type.CrossFade) {
      if (this.fromSegmentUuid === segment.uuid) {
        return segment.fadeOut(this.durationInFrames);
      } else if (this.toSegmentUuid === segment.uuid) {
        return segment.fadeIn(this.durationInFrames);
      }
    } else if (this.isSlideTransition) {
      if (this.fromSegmentUuid === segment.uuid) {
        return segment.slideOut(this.durationInFrames, this.type);
      } else if (this.toSegmentUuid === segment.uuid) {
        return segment.slideIn(this.durationInFrames, this.type);
      }
    }

    throw new Error(`Unsupported transition type: ${this.type}`);
  }

  public get fromSegmentUuid(): string {
    return this.json.fromSegmentUuid;
  }

  public get toSegmentUuid(): string {
    return this.json.toSegmentUuid;
  }

  public get type(): AnimatedSegmentTransitionModel.Type {
    return this.json.transitionType;
  }

  public get durationInFrames(): number {
    return this.json.durationInFrames;
  }

  private get isSlideTransition(): boolean {
    return (
      this.type === AnimatedSegmentTransitionModel.Type.SlideLeft ||
      this.type === AnimatedSegmentTransitionModel.Type.SlideRight ||
      this.type === AnimatedSegmentTransitionModel.Type.SlideUp ||
      this.type === AnimatedSegmentTransitionModel.Type.SlideDown
    );
  }
}

export namespace AnimatedSegmentTransitionModel {
  export interface IJson {
    fromSegmentUuid: string;
    toSegmentUuid: string;
    durationInFrames: number;
    transitionType: Type;
  }

  export enum Type {
    CrossFade = "cross_fade",
    SlideLeft = "slide_left",
    SlideRight = "slide_right",
    SlideUp = "slide_up",
    SlideDown = "slide_down",
    Custom = "custom",
    None = "none",
  }
}
/* v8 ignore stop */
